import { render, staticRenderFns } from "./dangjian.vue?vue&type=template&id=686c8b34&scoped=true&"
import script from "./dangjian.vue?vue&type=script&lang=js&"
export * from "./dangjian.vue?vue&type=script&lang=js&"
import style0 from "./dangjian.vue?vue&type=style&index=0&id=686c8b34&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686c8b34",
  null
  
)

export default component.exports